define('services/converters',[], function () {
    "use strict";

    function isFunction(fun) {
        return typeof fun === "function";
    }

    function isArray(array) {
        if (!array) {
            return false;
        }
        return array.constructor.toString().indexOf("Array") > -1;
    }

    function isLatLon(latlon) {
        return (latlon.hasOwnProperty("lat") && (latlon.hasOwnProperty("lon") || latlon.hasOwnProperty("lng")));
    }

    function or(first, second) {
        if (first === undefined) {
            return second;
        }
        return first;
    }

    function normalizeLatitude(latitude) {
        var numLatitude = parseFloat(latitude);
        if (!isFinite(numLatitude)) {
            throw new TypeError("an number is expected, but " + latitude + " [" + (typeof latitude) + "] given");
        }
        if (numLatitude < -90 || numLatitude > 90) {
            var sign = numLatitude < 0 ? -1 : 1;
            var i = Math.ceil(Math.abs(numLatitude) / 180);
            return numLatitude - sign * 180 * i;
        }
        return numLatitude;
    }

    function normalizeLongitude(longitude) {
        var numLongitude = parseFloat(longitude);
        if (!isFinite(numLongitude)) {
            throw new TypeError("an number is expected, but " + longitude + " [" + (typeof longitude) + "] given");
        }
        if (numLongitude < -180 || numLongitude > 180) {
            var sign = numLongitude < 0 ? -1 : 1;
            var i = Math.ceil(Math.abs(numLongitude) / 360);
            return numLongitude - sign * 360 * i;
        }
        return numLongitude;
    }

    function isXY(xy) {
        return xy.hasOwnProperty("x") && xy.hasOwnProperty("y");
    }

    function isLatitudeLongitude(value) {
        return value.hasOwnProperty("latitude") && value.hasOwnProperty("longitude");
    }

    function isLatLonFunction(value) {
        return isFunction(value.lat) && isFunction(value.lng);
    }

    function castPoint(value) {
        if (isArray(value) && value.length === 2) {
            return value;
        }
        if (typeof value === "string") {
            var match = value.match(/^(-?\d*(?:\.\d*)?)(?:\s+|\s*,\s*)(-?\d*(?:\.\d*)?)$/);
            if (!match || !match[1] || !match[2]) {
                throw new TypeError("A point is expected, but " + value + " [" + (typeof value) + "] given");
            }
            return [match[1], match[2]];
        }
        if (isLatLonFunction(value)) {
            return [value.lat(), value.lng()];
        }
        if (isLatLon(value)) {
            return [value.lat, or(value.lon, value.lng)];
        }
        if (isXY(value)) {
            return [value.y, value.x];
        }
        if (isLatitudeLongitude(value)) {
            return [value.latitude, value.longitude];
        }
        throw new TypeError("A point is expected, but " + value + " [" + (typeof value) + "] given");
    }

    function isLatLonBBox(bbox) {
        return bbox.hasOwnProperty("minLon") && bbox.hasOwnProperty("minLat") && bbox.hasOwnProperty("maxLon") && bbox.hasOwnProperty("maxLat");
    }

    function isRightLeftTopBottomBBox(bbox) {
        return bbox.hasOwnProperty("left") && bbox.hasOwnProperty("bottom") && bbox.hasOwnProperty("right") && bbox.hasOwnProperty("top");
    }

    function isWestEastNorthSouthBBox(bbox) {
        return isFunction(bbox.getWest) && isFunction(bbox.getEast) && isFunction(bbox.getSouth) && isFunction(bbox.getNorth);
    }

    function castBoundingBox(bbox) {
        var sw, ne;
        if (isLatLonBBox(bbox)) {
            return bbox;
        }
        if (isRightLeftTopBottomBBox(bbox)) {
            return {minLon: bbox.left, minLat: bbox.bottom, maxLon: bbox.right, maxLat: bbox.top};
        }
        if (isWestEastNorthSouthBBox(bbox)) {
            return {minLon: bbox.getWest(), minLat: bbox.getSouth(), maxLon: bbox.getEast(), maxLat: bbox.getNorth()};
        }
        if (isFunction(bbox.getNorthEast) && isFunction(bbox.getSouthWest)) {
            ne = castPoint(bbox.getNorthEast());
            sw = castPoint(bbox.getSouthWest());
            return {minLon: sw[1], minLat: sw[0], maxLon: ne[1], maxLat: ne[0]};
        }
        if (isArray(bbox) && bbox.length === 4) {
            return {minLon: bbox[0], minLat: bbox[1], maxLon: bbox[2], maxLat: bbox[3]};
        }
        if (isArray(bbox) && bbox.length === 2) {
            sw = castPoint(bbox[0]);
            ne = castPoint(bbox[1]);
            return {minLon: sw[1], minLat: sw[0], maxLon: ne[1], maxLat: ne[0]};
        }
        if (typeof bbox === "string") {
            bbox = bbox.trim().split(/\s*,\s*/);
            if (bbox.length === 4) {
                return {
                    minLon: parseFloat(bbox[0]),
                    minLat: parseFloat(bbox[1]),
                    maxLon: parseFloat(bbox[2]),
                    maxLat: parseFloat(bbox[3])
                };
            }
        }
        throw new TypeError("Unable to cast " + bbox + " [" + typeof bbox + "] to bounding box");
    }

    function normalizeBoundingBox(bbox) {
        var w = bbox.minLon, e = bbox.maxLon, s = bbox.minLat, n = bbox.maxLat;
        if (e - w > 360) {
            e = 180;
            w = -180;
        } else {
            if (e > 270) {
                var right = Math.ceil(w / 360);
                e -= 360 * right;
                w -= 360 * right;
            }
            if (w < -270) {
                var left = Math.ceil(-e / 360);
                e += 360 * left;
                w += 360 * left;
            }
        }
        s = s < -90 ? -90 : s;
        n = n > 90 ? 90 : n;
        return {minLon: w, minLat: s, maxLon: e, maxLat: n};
    }

    var trafficIncidentsLanguageMapping = {
        "ca": ["ca", "cat", "ca-fr", "ca_fr", "ca-es", "ca_es", "catalan"],
        "cs": ["cs", "cze", "cs-cz", "cs_cz", "czech"],
        "da": ["da", "dan", "da-dk", "da_dk", "danish"],
        "de": ["de", "ger", "de-de", "de_de", "german"],
        "en": ["en", "eng", "en-gb", "en_gb", "english", "us", "ame", "en-us", "en_us", "english US", "default"],
        "es": ["es", "spa", "es-es", "es_es", "spanish", "mx", "spm", "es-mx", "es_mx", "spanish MX"],
        "fi": ["fi", "fin", "fi-fi", "fi_fi", "finnish"],
        "fr": ["fr", "fre", "fr-fr", "fr_fr", "french"],
        "hu": ["hu", "hun", "hu-hu", "hu_hu", "hungarian"],
        "it": ["it", "ita", "it-it", "it_it", "italian"],
        "nl": ["nl", "dut", "nl-nl", "nl_nl", "dutch"],
        "no": ["no", "nor", "no-no", "no_no", "norwegian"],
        "pl": ["pl", "pol", "pl-pl", "pl_pl", "polish"],
        "pt": ["br", "por", "pt-br", "pt_br", "portuguese", "pt", "pob", "pt-pt", "pt_pt", "portuguese BR"],
        "sk": ["sk", "slo", "sk-sk", "sk_sk", "slovak"],
        "sv": ["sv", "swe", "sv-se", "sv_se", "swedish"],
        "tr": ["tr", "tur", "tr-tr", "tr_tr", "turkish"],
        defaultValue: "en"
    }, routingGuidanceLanguageMapping = {
        "ar": ["ar", "ara", "ar-ar", "ar_ar", "arabic"],
        "af-ZA": ["af", "afr", "af-za", "af_za", "afrikaans"],
        "bg-BG": ["bg", "bul", "bg-bg", "bg_bg", "bulgarian"],
        "zh-TW": ["zh", "chi", "zh-tw", "zh_tw", "chinese"],
        "cs-CZ": ["cs", "cz", "cze", "cs-cz", "cs_cz", "czech"],
        "da-DK": ["da", "dan", "da-dk", "da_dk", "danish"],
        "nl-NL": ["nl", "dut", "nl-nl", "nl_nl", "dutch"],
        "en-GB": ["en", "eng", "en-gb", "en_gb", "english", "default"],
        "en-US": ["us", "ame", "en-us", "en_us", "english US"],
        "fi-FI": ["fi", "fin", "fi-fi", "fi_fi", "finnish"],
        "fr-FR": ["fr", "fre", "fr-fr", "fr_fr", "french"],
        "de-DE": ["de", "ger", "de-de", "de_de", "german"],
        "el-GR": ["el", "gre", "el-gr", "el_gr", "greek"],
        "hu-HU": ["hu", "hun", "hu-hu", "hu_hu", "hungarian"],
        "id-ID": ["id", "ind", "id-id", "id_id", "indonesian"],
        "it-IT": ["it", "ita", "it-it", "it_it", "italian"],
        "ko-KR": ["ko", "kor", "ko-kr", "ko_kr", "korean"],
        "lt-LT": ["lt", "lit", "lt-lt", "lt_lt", "lithuanian"],
        "ms-MY": ["ms", "mal", "ms-my", "ms_my", "malay"],
        "nb-NO": ["nb", "nor", "nb-no", "nb_no", "norwegian"],
        "pl-PL": ["pl", "pol", "pl-pl", "pl_pl", "polish"],
        "pt-BR": ["br", "por", "pt-br", "pt_br", "portuguese"],
        "pt-PT": ["pt", "pob", "pt-pt", "pt_pt", "portuguese BR"],
        "ru-RU": ["ru", "rus", "ru-ru", "ru_ru", "russian"],
        "sk-SK": ["sk", "slo", "sk-sk", "sk_sk", "slovak"],
        "sl-SI": ["sl", "slv", "sl-si", "sl_si", "slovenian"],
        "es-ES": ["es", "spa", "es-es", "es_es", "spanish"],
        "es-MX": ["mx", "spm", "es-mx", "es_mx", "spanish MX"],
        "sv-SE": ["sv", "swe", "sv-se", "sv_se", "swedish"],
        "th-TH": ["th", "tha", "th-th", "th_th", "thai"],
        "tr-TR": ["tr", "tur", "tr-tr", "tr_tr", "turkish"],
        defaultValue: "en-GB"
    };

    function circleFromString(value) {
        var match = value.match(/^circle\((-?\d*(?:\.\d*)?)\s*,\s*(-?\d*(?:\.\d*)?)\s*,\s*(\d+)\)$/);
        if (!match || !match[1] || !match[2] || !match[3]) {
            throw new TypeError("Unable to cast " + value + " [" + typeof value + "] to circle");
        }
        var lat = parseFloat(match[1]), lon = parseFloat(match[2]), radius = parseFloat(match[3]);
        if (!isFinite(lat) || !isFinite(lon)) {
            throw new TypeError("Unable to cast " + value + " [" + typeof value + "] to circle");
        }
        return "circle(" + lat + "," + lon + "," + radius + ")";
    }

    function castAndNormalizePoint(value) {
        var point = castPoint(value);
        return normalizeLatitude(point[0]) + "," + normalizeLongitude(point[1]);
    }

    function convertPointOrCircle(value) {
        if (typeof value === "string" && value.indexOf("circle") > -1) {
            return circleFromString(value);
        }
        if (isArray(value) && value.length === 3) {
            return "circle(" + normalizeLatitude(value[0]) + "," + normalizeLongitude(value[1]) + "," + value[2] + ")";
        }
        return castAndNormalizePoint(value);
    }

    function extractPointsFromPolygon(inputPoints) {
        var points = [],
            point;
        for (point in inputPoints) {
            if (inputPoints.hasOwnProperty(point)) {
                points.push(castAndNormalizePoint(inputPoints[point]));
            }
        }
        return points;
    }

    return {
        boundingBox: function (value) {
            return normalizeBoundingBox(castBoundingBox(value));
        },

        longitude: function (value) {
            return normalizeLongitude(value);
        },

        latitude: function (value) {
            return normalizeLatitude(value);
        },

        point: function (value) {
            return castAndNormalizePoint(value);
        },

        dateTime: function (value) {
            if (!value || typeof(value) !== "string") {
                throw new TypeError("Unable to cast " + value + " [" + typeof value + "] to datetime value.");
            }
            if (value !== "now") {
                value = value.replace(new RegExp(/-/, "g"), "/");
                value = new Date(value).toISOString();
            }
            return value;
        },

        geometryList: function (value) {
            if (!value || !isArray(value)) {
                throw new TypeError("Unable to cast " + value + " [" + typeof value + "] to geometry list (array)");
            }

            for (var figureName in value) {
                if (value.hasOwnProperty(figureName)) {
                    var figure = value[figureName];
                    if (figure.type === "POLYGON") {
                        figure.vertices = extractPointsFromPolygon(figure.vertices);
                    } else if (figure.type === "CIRCLE") {
                        figure.position = castAndNormalizePoint(figure.position);
                    }
                }
            }
            return value;
        },

        routingGuidanceLanguage: function (value) {
            value = value.toLowerCase();
            for (var language in routingGuidanceLanguageMapping) {
                // if language is found in one of properties array
                if (routingGuidanceLanguageMapping.hasOwnProperty(language) && routingGuidanceLanguageMapping[language].indexOf(value) > -1) {
                    return language;
                }
            }
            return routingGuidanceLanguageMapping.defaultValue;
        },

        trafficIncidentsLanguage: function (value) {
            value = value.toLowerCase();
            for (var language in trafficIncidentsLanguageMapping) {
                // if language is found in one of properties array
                if (trafficIncidentsLanguageMapping.hasOwnProperty(language) && trafficIncidentsLanguageMapping[language].indexOf(value) > -1) {
                    return language;
                }
            }
            return trafficIncidentsLanguageMapping.defaultValue;
        },

        routingLocations: function (value) {
            if (typeof value === "string") {
                return value;
            }
            if (isArray(value)) {
                if (value.length < 2) {
                    throw new TypeError("Unable to cast " + value + " [" + typeof value + "] to routing locations string");
                }
                var response = [];

                // Convert first element to point
                response.push(castAndNormalizePoint(value[0]));

                // Convert elements from 1 to length-2 to point or circle
                for (var i = 1; i < value.length - 1; i += 1) {
                    response.push(convertPointOrCircle(value[i]));
                }

                // Convert last element (length-1) to point
                response.push(castAndNormalizePoint(value[value.length - 1]));

                // Join converted elements
                return response.join(":");
            }
            throw new TypeError("Unable to cast " + value + " [" + typeof value + "] to routing locations string");
        },

        roadUse: function (value) {
            if (typeof value === "string") {
                return '["' + value.replace(/["']|^\s+|\s+$/g, "").split(/[\s,]+/).join('","') + '"]';
            }
            if (isArray(value)) {
                for (var i = 0; i < value.length; i += 1) {
                    value[i] = String(value[i]).replace(/["']|^\s+|\s+$/g, "");
                }
                return '["' + value.join('","') + '"]';
            }
            throw new TypeError("Unable to cast " + value + " [" + typeof value + "] to road use string");
        },

        arrayOfStrings: function (value) {
            if (!value) {
                return [];
            }
            if (typeof value === "string") {
                value = value.trim().replace(/\s*[,;]\s*/g, ',');
                return value.split(/[,;]+/);
            }
            if (isArray(value)) {
                return value;
            }
            throw new TypeError("Unable to cast " + value + " [" + typeof value + "] to array of strings");
        }
    };
});

